import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import NoImage from "../../../assests/images/gnp_noimg.png"
import TwitterXIcon from "../../../assests/images/xicon.svg";
import FacebookIcon from "../../../assests/images/facebook.svg";
import HeartIcon from "../../../assests/images/greatnonprofits-white-heart.webp";
import Start_icon from "../../../assests/images/Icon awesome-star.svg";
import {
    ReviewPreviewSection,
    ReviewPreviewHeading,
    ReviewPreviewTitle,
    ReviewPreviewStrong,
    YourReviewSection,
    YourReviewGroup,
    YourReviewWrap,
    YourReviewTitle,
    YourImpactWrap,
    YourImpactGroup,
    YourImpactTitle,
    YourImpactButtonWrap,
    YourImpactButton,
    ButtonIcon,
    ButtonLabel,
    ReviewBottomSection,
    ReviewButtonGroup,
    ReviewRole,
    Reviewstart,
    ReviewTimecol,
    Reviewcontent,
    ReviewImageVideo,
    ImageVideoCol,
    DonaterName,
    Rolecol,
    Donorcol,
} from "./reviewPreview";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MetaComponent from "../../../components/common/metaComponent";
import { ProfileDetails, ProfileImage, ProfileName } from "../../../components/common/profile/profileStyle";
import DeletereviewModal from "../../../components/common/modal/deletereviewModal"
import { StarList } from "../../../components/common/ratingStar/ratingStarStyle";
import moment from "moment";
import { retrieveReviewsHandler } from "../../../redux/slices/donationCamp/retrieveReviews-slice";
import { MESSAGE } from "../../../utils/message";

const reactUrl = import.meta.env.VITE_WEBSITE_URL;

const ReviewPreview = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const user_id = typeof localStorage !== "undefined" && localStorage.getItem("userId")
    const { state } = useLocation();
    const dispatch = useDispatch();

    const addEditReviewResults = useSelector((state: any) => state?.addEditReview?.data?.results);
   
    

    let profileReviews = useSelector((state: any) => state.retrieveReview?.data?.results);

    const [deleteReviewId, setDeleteReviewId] = useState("");

    const fullStars = Math.floor(profileReviews?.rating);
    const hasHalfStar = profileReviews?.rating % 1 !== 0;

    const [editDeletereviewOpen, setEditDeletereviewOpen] = useState(false);



    useEffect(() => {
        dispatch(retrieveReviewsHandler(addEditReviewResults?.review_id || id) as any)
    }, [addEditReviewResults?.review_id])

    useEffect(() => {
        state?.review_id && dispatch(retrieveReviewsHandler(state?.review_id || id) as any)
    }, [state?.review_id])
    const getShareUrl = (platform: any) => {
        const url = `${reactUrl}/review/${id}`;

        switch (platform) {
            case 'facebook':
                return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
            case 'twitter':
                return `https://twitter.com/intent/tweet?url=${url}`;
            default:
                return '#';
        }
    };
    return (
        <>
            <MetaComponent
                keywords=""
                description=""
                ogTitle=""
                ogDescription=""
                ogUrl=""
                ogImage="https://cdn.greatnonprofits.org/img/dashboard/gnp_bug-orange.png"
            />
            <ReviewPreviewSection>
                <Container className="cont-w">
                    <Row>
                        <Col lg="12">
                            <ReviewPreviewHeading>
                                <ReviewPreviewTitle>
                                    Thank you for sharing your story! Your review of{" "}
                                    <ReviewPreviewStrong
                                        onClick={() => navigate(`/org/${profileReviews?.nonprofit_slug}`)}
                                    >
                                        {profileReviews?.nonprofit_title}
                                    </ReviewPreviewStrong>{" "}
                                    has been posted.
                                </ReviewPreviewTitle>

                            </ReviewPreviewHeading>
                        </Col>
                    </Row>
                </Container>
            </ReviewPreviewSection>

            <YourReviewSection>
                <Container className="cont-w">
                    <Row>
                        <Col sm="12">
                            <YourReviewGroup>
                                <YourReviewWrap>
                                    <YourReviewTitle>Your Review</YourReviewTitle>
                                    <ProfileImage><Image src={profileReviews?.profile_picture || NoImage} alt={"profile picture"} /></ProfileImage>
                                    <ProfileDetails>
                                        <ProfileName className='profile-user-name'>{profileReviews?.username}</ProfileName>

                                    </ProfileDetails>
                                </YourReviewWrap>

                                <YourImpactWrap>
                                    {/* <NonprofitReviews reviewData={profileReviews} page={"my-review"}/> */}
                                    <ReviewRole>
                                        <Reviewstart>
                                            {profileReviews?.rating > 0 && <StarList className="rating-star">
                                                {[...Array(fullStars)]?.map((_, index) => (<Image key={index + 1} src={Start_icon} className="full-star" alt="rating star" width="15px" height="14px" />
                                                ))}
                                                {hasHalfStar && (
                                                    <Image src={Start_icon} className="half-star" alt="rating star" width="15px" height="14px" />
                                                )}
                                            </StarList>}
                                            <ReviewTimecol>{profileReviews?.created
                                                ? moment(profileReviews?.created).format("MMM D, YYYY")
                                                : "-"}</ReviewTimecol>
                                        </Reviewstart>
                                        <Reviewcontent>{profileReviews?.review}</Reviewcontent>
                                        <ReviewImageVideo>
                                            {profileReviews?.images?.map((url: string, index: number) => (<ImageVideoCol key={index + 1}>
                                                <Image src={url} />
                                            </ImageVideoCol>))}

                                            {profileReviews?.videos?.map((url: string, index: number) => (
                                                <ImageVideoCol key={index + 1}>
                                                    <div className="iframe-container">
                                                        <iframe src={url} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                                                    </div>
                                                </ImageVideoCol>))}
                                        </ReviewImageVideo>
                                        <DonaterName>
                                            <Rolecol>Role:</Rolecol>
                                            <Donorcol>{profileReviews?.role}</Donorcol>
                                        </DonaterName>
                                    </ReviewRole>
                                    <YourImpactGroup>
                                        <YourImpactTitle>Increase Your Impact</YourImpactTitle>
                                        <YourImpactButtonWrap>

                                            <YourImpactButton className="facebook-btn" href={getShareUrl('facebook')} target="_blank">
                                                <ButtonIcon><Image src={FacebookIcon} /></ButtonIcon>
                                                <ButtonLabel>Share your review on Facebook</ButtonLabel>
                                            </YourImpactButton>

                                            <YourImpactButton className="twitter-btn" href={getShareUrl('twitter')} target="_blank">
                                                <ButtonIcon><Image src={TwitterXIcon} /></ButtonIcon>
                                                <ButtonLabel>Share your review on Twitter</ButtonLabel>
                                            </YourImpactButton>

                                            {/* <YourImpactButton className="review-btn" href={getShareUrl('twitter')} target="_blank">
                                                <ButtonIcon><Image src={HeartIcon} /></ButtonIcon>
                                                <ButtonLabel>Share your review on Twitter</ButtonLabel>
                                            </YourImpactButton> */}
                                            <YourImpactButton className="review-btn" onClick={() => navigate(`/users/profile/${user_id}/fundraisers/create/${addEditReviewResults?.review_id}/${profileReviews?.org_id}`)}>
                                                <ButtonIcon><Image src={HeartIcon} /></ButtonIcon>
                                                <ButtonLabel>{MESSAGE.createFundRaiser}</ButtonLabel>
                                            </YourImpactButton>
                                        </YourImpactButtonWrap>
                                    </YourImpactGroup>
                                </YourImpactWrap>
                            </YourReviewGroup>
                        </Col>
                    </Row>
                </Container>
            </YourReviewSection>

            <ReviewBottomSection>
                <Container className="cont-w">
                    <Row>
                        <Col lg="12">
                            <ReviewButtonGroup>
                                <Button className="btn-outline-success-blue btn btn-primary" onClick={() => navigate(`/write-review/${id}`, { state: { editReview: profileReviews?.id } })}>Edit this Review</Button>
                                <Button className="learn-qualify-btn  btn btn-primary" onClick={() => { setEditDeletereviewOpen(true); setDeleteReviewId(profileReviews?.id) }}>Delete Review</Button>
                                <Button className="write-yellow-btn btn btn-primary" onClick={() => navigate(`/org/${profileReviews?.nonprofit_slug}`)}>Go Back to Nonprofit Profile</Button>
                            </ReviewButtonGroup>
                        </Col>
                    </Row>
                </Container>
            </ReviewBottomSection>

            <DeletereviewModal editDeletereviewOpen={editDeletereviewOpen} setDeletereviewOpen={setEditDeletereviewOpen} deleteReviewId={deleteReviewId} slug={profileReviews?.nonprofit_slug} />
        </>
    )
};
export default ReviewPreview; 